export default "/_next/static/src/lib/assets/rive/88ee80d449110dc910f7be895d64b67e.riv";